// 상단 메뉴
const header = {
  ko: {
    mainMenu: '메인 메뉴',
    register: '참가 신청',
    participants: '참가 목록',
    tournament: '토너먼트',
    adminTournament: '토너먼트 관리',
    adminMembers: '회원 관리',
    publicView: '공개 화면',
  },
  en: {
    mainMenu: 'Main menu',
    register: 'Register',
    participants: 'Participants',
    tournament: 'Tournament',
    adminTournament: 'Manage Tournament',
    adminMembers: 'Members',
    publicView: 'Public View',
  },
};

export default header;
